module.exports = __webpack_public_path__ + "media/images/eb_logo-7d8939bd57469cfb6fdd30347f4618d1.png";